/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\OtherSVG\CartSVG.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday March 16th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday March 16th 2023 3:38:18 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function CartSVG(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
           <path d="M132.52,210.94c0-14,11.35-25.35,25.35-25.35h76.04c11.63,0,21.77,7.93,24.59,19.21l20.53,82.18H867.58c14,.01,25.34,11.37,25.32,25.37,0,1.56-.15,3.11-.43,4.64l-76.04,405.55c-2.24,11.98-12.7,20.67-24.89,20.68H335.29c-12.19-.01-22.65-8.7-24.89-20.68l-75.99-404.79-20.28-81.47h-56.27c-14,0-25.35-11.35-25.35-25.35Zm253.47,532.29c-56,0-101.39,45.39-101.39,101.39s45.39,101.39,101.39,101.39,101.39-45.39,101.39-101.39-45.39-101.39-101.39-101.39Zm354.86,0c-56,0-101.39,45.39-101.39,101.39s45.39,101.39,101.39,101.39,101.39-45.39,101.39-101.39-45.39-101.39-101.39-101.39Zm-354.86,50.69c28,0,50.69,22.7,50.69,50.69s-22.7,50.69-50.69,50.69-50.69-22.7-50.69-50.69,22.7-50.69,50.69-50.69Zm354.86,0c28,0,50.69,22.7,50.69,50.69s-22.7,50.69-50.69,50.69-50.69-22.7-50.69-50.69,22.7-50.69,50.69-50.69Z"/>
        </svg>
    );
}

export default CartSVG;
